import { render, staticRenderFns } from "./OrderInquiry.vue?vue&type=template&id=a56db08e&scoped=true"
import script from "./OrderInquiry.vue?vue&type=script&lang=js"
export * from "./OrderInquiry.vue?vue&type=script&lang=js"
import style0 from "./OrderInquiry.vue?vue&type=style&index=0&id=a56db08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56db08e",
  null
  
)

export default component.exports